import React from 'react';

import './Step.scss';
import { StepProps } from './types';

const Step: React.FC<StepProps> = ({ title, body, hint }) => {
  return (
    // Debe ir como fragmento si no presenta problemas con el tour
    <>
      <div className="step__title">{title}</div>
      <div className="step__body">{body}</div>
      <div className="step__hint">{hint}</div>
    </>
  );
};
export default Step;
